import { statusBadgeMap } from 'modules/incentivesMarket/constants/incentiveOfferOperationStatus';
import { IncentiveOfferOperation } from 'modules/incentivesMarket/types';

type IncentiveOperationRowData = {
  units: number;
  totalPriceUnits: number;
  soldUnits: number;
  totalPriceSoldUnits: number;
  netAmount: number;
  retentionPercent: number;
  status: { value: string; style: string };
};

const getIncentiveOperationRowData = (
  operation: IncentiveOfferOperation
): IncentiveOperationRowData => {
  const units = operation.unitsCount || 0;
  const unitPrice = operation.unitPrice || 0;
  const grossAmount = units * unitPrice;

  const badge = statusBadgeMap[operation.status] || {
    className: 'badge-secondary',
    label: operation.status,
  };

  return {
    units,
    totalPriceUnits: grossAmount,
    soldUnits: units,
    totalPriceSoldUnits: grossAmount,
    retentionPercent: 0,
    netAmount: operation.totalPrice ?? 0,
    status: {
      value: badge.label,
      style: badge.className,
    },
  };
};

export default getIncentiveOperationRowData;
